import React from "react";
import { Card, Tag, Typography } from "antd";
import { BankOutlined, ApartmentOutlined } from "@ant-design/icons";

const { Text } = Typography;

function BalanceStat({ label, value, colorClass = "text-slate-900", bgClass = "bg-slate-50" }) {
  return (
    <div className={`flex flex-col gap-1 rounded-xl px-4 py-3 ${bgClass}`}>
      <span className="text-[12px] font-semibold uppercase tracking-[0.1em] text-slate-400">
        {label}
      </span>
      <span className={`text-[16px] font-semibold leading-tight ${colorClass}`}>
        {value}
      </span>
    </div>
  );
}

export function BankAccountCard({
  account,
  formatAccountNumber,
  formatMoney,
  getBankLabel,
}) {
  return (
    <Card
      bordered={false}
      className="rounded-xl shadow-sm"
      styles={{ body: { padding: 0 } }}
    >
      {/* Account identity row */}
      <div className="flex flex-wrap items-center gap-3 border-b border-slate-100 px-5 py-4">
        <BankOutlined className="text-lg text-slate-400" />
        <span className="font-mono text-lg font-bold tracking-wide text-slate-900">
          {formatAccountNumber(account?.accountNumber) || "—"}
        </span>
        <Tag color="blue">{getBankLabel(account?.bank)}</Tag>
        <Tag color="green">{account?.currency ?? "—"}</Tag>
      </div>

      {/* Balance grid */}
      <div className="grid grid-cols-2 gap-3 p-4 md:grid-cols-4">
        <BalanceStat
          label="Gmail үлдэгдэл"
          value={formatMoney(account?.gmailBalance, account?.currency)}
        />
        <BalanceStat
          label="Ориг үлдэгдэл"
          value={formatMoney(account?.balance, account?.currency)}
          colorClass="text-blue-700"
          bgClass="bg-blue-50"
        />
        <BalanceStat
          label="Хуулганы үлдэгдэл"
          value={formatMoney(account?.lastStatementBalance, account?.currency)}
          colorClass="text-amber-700"
          bgClass="bg-amber-50"
        />
        <BalanceStat
          label="Хийсвэр үлдэгдэл"
          value={formatMoney(account?.walletBalance, account?.currency)}
          colorClass="text-emerald-700"
          bgClass="bg-emerald-50"
        />
      </div>
    </Card>
  );
}

export function InstitutionCard({ institution, getInstitutionTypeLabel }) {
  return (
    <Card
      bordered={false}
      className="h-full rounded-xl shadow-sm"
      styles={{ body: { padding: 0 } }}
    >
      <div className="flex h-full flex-col px-5 py-4">
        <div className="mb-3 flex items-center gap-2 text-slate-400">
          <ApartmentOutlined />
          <span className="text-[10px] font-semibold uppercase tracking-[0.1em]">
            Байгааллага
          </span>
        </div>

        {institution ? (
          <>
            <span className="text-[17px] font-semibold leading-snug text-slate-900">
              {institution.name}
            </span>
            <div className="mt-2">
              <Tag color="purple">
                {getInstitutionTypeLabel(institution.type)}
              </Tag>
            </div>
          </>
        ) : (
          <Text type="secondary" className="text-sm">
            Холбогдсон байгааллага байхгүй
          </Text>
        )}
      </div>
    </Card>
  );
}
